import { jsonSitiosArqueologicosGeorreferenciadosPE8 } from "../LocalStore/Stios_Arqueolgicos_Georreferenciados_PE_8";

const TEXT_FIELDS = [
  "identifica",
  "ds_naturez",
  "ds_classif",
  "ds_tipo_be",
  "sintese_be",
] as const;

type CorrectedProps = Partial<Record<(typeof TEXT_FIELDS)[number], string>>;

const correctionsById = new Map<number, CorrectedProps>();
const correctionsByText = new Map<string, string>();

function toCorrupted(text: string): string {
  return text.replace(/[^\x00-\x7F]/g, "");
}

jsonSitiosArqueologicosGeorreferenciadosPE8.features.forEach((feature) => {
  const p = feature.properties as Record<string, any>;
  if (p.id_bem == null) return;

  const id = Math.round(Number(p.id_bem));
  const corrected: CorrectedProps = {};

  TEXT_FIELDS.forEach((field) => {
    const value = p[field];
    if (typeof value !== "string" || value.trim() === "") return;

    corrected[field] = value;

    const corrupted = toCorrupted(value);
    if (corrupted !== value && corrupted.length >= 4) {
      correctionsByText.set(corrupted, value);
    }
  });

  correctionsById.set(id, corrected);
});

export function applySitiosArqueologicosCorrections(
  properties: Record<string, any>
): Record<string, any> {
  if (properties.id_bem == null) return properties;

  const id = Math.round(Number(properties.id_bem));
  const correction = correctionsById.get(id);

  if (!correction) return properties;
  return { ...properties, ...correction };
}

export function applyCorrectionsToWMSHtml(
  layerName: string,
  html: string
): string {
  if (!layerName.includes("sitios_arqueologicos")) return html;

  let result = html;
  correctionsByText.forEach((correct, corrupted) => {
    if (result.includes(corrupted)) {
      result = result.split(corrupted).join(correct);
    }
  });
  return result;
}
